import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    ACTIVE: 'Active',
    CREATED: 'Creation in progress',
    DEACTIVATED: 'Deactivated',
    INACTIVE: 'Inactive',
    LOCKED: 'Locked',
    LOST: 'Lost',
    pendingAutomaticVirtualCard: 'Creation in progress',
    STOLEN: 'Stolen',
  },
  fr: {
    ACTIVE: 'Active',
    CREATED: 'En cours de création',
    DEACTIVATED: 'Désactivée',
    INACTIVE: 'Inactive',
    LOCKED: 'Bloquée',
    LOST: 'Perdue',
    pendingAutomaticVirtualCard: 'En cours de création',
    STOLEN: 'Volée',
  },
});

export default locales;
